<template>
  <div class="container" :class="{'connection-container': errorDescription.a}">
    <div class="error-icon uk-width-1-1 uk-flex uk-flex-center">
      <img :src="errorIcon">
    </div>
    <h1 class="heading uk-text-center">{{errorHeading}}</h1>
    <span v-if="errorDescription.a">
      <div class="uk-flex uk-flex-center">
        <p class="description uk-text-center uk-margin-small">{{errorDescription.a}}<br>{{errorDescription.b}}</p>
        </div>
    </span>
    <div v-else class="uk-flex uk-flex-center">
      <p class="description uk-text-center uk-margin-small" v-html="errorDescription"></p>
    </div>
    <div v-if="showSearch" class="uk-width-1-1 uk-margin-medium-top">
      <div class="uk-flex uk-flex-center">
        <search-box></search-box>
      </div>
    </div>
    <div class="uk-width-1-1 uk-text-center code-container">
      <span class="code">{{errorCode}}</span>
    </div>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'
  import * as url from '../../enums/static-urls'
  import searchBox from '../navigation-bar/search-box'

  export default {
    name: 'error-fullpage',
    components: {searchBox},
    props: ['errorHeading', 'errorDescription', 'errorCode', 'showSearch'],
    data() {
      return {
        dirtyText: null,
        errorIcon: iconUtil.resolve(misc.ERROR_INFO_ICON)
      }
    },
    methods: {
      ...mapMutations(['setQueuesDefault']),
      openLegacySMEX() {
        window.open(url.LEGACY_EXCHANGE_DOMAIN, '_blank')
      }
    },
    mounted() {
      this.setQueuesDefault()
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/breakpoints.scss';
  @import '../../styles/colours.scss';

  .container {
    padding-left: 7%;
    padding-right: 7%;
    padding-top: 35px;
  }

  .uk-heading-primary {
    color: rgba(0, 1, 2, 0.7);
  }

  .heading {
    font-size: 20px;
    font-weight: bold;
    color: rgba(0, 1, 2, 0.7);
  }

  .description {
    /deep/
    a {
      color: $content-link-blue;
      font-weight: bold;
    }

    font-size: 16px;
    color: rgba(0, 1, 2, 0.7);
    max-width: 920px;
    line-height: 1.59;
  }

  .hint {
    text-align: center;
    font-size: 17px;
  }

  .link {
    font-size: 17px;
    color: $content-link-blue;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .code {
    font-size: 16.8px;
    line-height: 32.9px;
    color: rgba(0, 1, 2, 0.4);
  }

  @media screen and (min-width: $breakpoint-small) and (max-width: $breakpoint-medium) {
    .container {
      padding-top: 135px;
    }
  }

  @media screen and (min-width: $breakpoint-small) {
    .heading {
      font-size: 38px;
    }
    .description {
      max-width: 920px;
      font-size: 28px;
    }
    .link {
      font-size: 17px;
    }
    .code {
      font-size: 24px;
    }
  }

  @media screen and (min-width: $breakpoint-medium) {
    .heading {
      font-size: 38px;
    }
    .description {
      max-width: 920px;
      font-size: 28px;
    }
    .hint {
      font-size: 17px;
    }

    .link {
      font-size: 17px;
    }
    .code-container {
      margin-top: 27px;
    }
    .code {
      font-size: 24px;
    }

    .connection-container{
      padding-top: 150px;
    }
  }

  @media screen and (min-width: $breakpoint-xlarge) {
    .heading {
      font-size: 41px;
    }
    .description {
      max-width: 920px;
      font-size: 33px;
    }
    .hint {
      font-size: 22px;
    }
    .link {
      font-size: 22px;
    }
    .code {
      font-size: 24px;
    }
  }

</style>
